import { ROUTE_NAMES } from "@root/constants";
import DashboardLayout from "@root/layouts/DashboardLayout";
import { createBrowserRouter, Navigate } from "react-router-dom";
import CourseManagement from "@root/pages/kpec-admin/course-management";
import CourseCreate from "@root/pages/kpec-admin/course-management/create";
import SetPreference from "@root/components/kpec-admin/course-management/CourseStep3";
import CategoryManagement from "@root/components/CategoryManagement/index";
import { LoginAdmin } from "@root/pages/auth/login/loginAdmin";
import FAQnQAPage from "@root/pages/faq/faqnQA";
import { AdminNotice } from "@root/components/AdminNotice/AdminNotice";
import SubscriberManagement from "@root/pages/kpec-admin/subscriber-management/subscriber-management";
import { MyProfile } from "@root/pages/profilesection-journalist/myprofile";
import { FaqProvider } from "@root/context/faq-context";
import { ResourcesProvider } from "@root/context/resources-context";
import { NoticeTypeProvider } from "@root/context/notice-type-context";
import { UpdateProfile } from "@root/pages/profilesection-journalist/updateprofile/updateprofile";
import AdminJournalistManagment from "@root/components/admin-journalist-managment/Index";
import { InquiryContextProvider } from "@root/context/inquiries";
import { SubscriberContextProvider } from "@root/context/use-subscriber-context";
import { ForgotPassword } from "@root/pages";
import SubscriberCourses from "@root/pages/kpec-admin/subscriber-management/subscriber-courses";
import SubscriberMembers from "@root/pages/kpec-admin/subscriber-management/subscriber-members";
import Test from "@root/pages/test";

export const adminRoutes = createBrowserRouter([
  {
    path: "/",
    element: (
      <SubscriberContextProvider>
        <InquiryContextProvider>
          <NoticeTypeProvider>
            <ResourcesProvider>
              <FaqProvider>
                <DashboardLayout />
              </FaqProvider>
            </ResourcesProvider>
          </NoticeTypeProvider>
        </InquiryContextProvider>
      </SubscriberContextProvider>
    ),
    children: [
      {
        path: "/",
        element: <Navigate to={ROUTE_NAMES.COURSE_MANAGEMENT} />,
      },
      {
        path: ROUTE_NAMES.COURSE_MANAGEMENT,
        element: <CourseManagement />,
      },
      {
        path: ROUTE_NAMES.COURSE_CREATE,
        element: <CourseCreate />,
      },
      {
        path: ROUTE_NAMES.FORGET_PASSWORD,
        element: <ForgotPassword />,
      },
      {
        path: ROUTE_NAMES.FAQS,
        element: <FAQnQAPage />,
      },
      {
        path: ROUTE_NAMES.ADMIN_NOTICE,
        element: <AdminNotice />,
      },
      {
        path: ROUTE_NAMES.COURSE_SET_PREFERENCE,
        element: <SetPreference />,
      },
      {
        path: ROUTE_NAMES.CATEGORY_MANAGEMENT,
        element: <CategoryManagement />,
      },
      {
        path: ROUTE_NAMES.USER_SUBSCRIPTION,
        element: <SubscriberManagement />,
      },
      {
        path: ROUTE_NAMES.USER_PROFILE,
        element: <MyProfile />,
      },
      {
        path: ROUTE_NAMES.UPDATE_PROFILE,
        element: <UpdateProfile />,
      },
      {
        path: ROUTE_NAMES.ADMIN_JOURNALIST_MANAGEMENT,
        element: <AdminJournalistManagment />,
      },
      {
        path: ROUTE_NAMES.COURSE_EDIT,
        element: <CourseCreate />,
      },
      {
        path: ROUTE_NAMES.SUBSCRIBER_COURSE_ADMIN,
        element: <SubscriberCourses />,
      },
      {
        path: ROUTE_NAMES.SUBSCRIBER_MEMBERS_ADMIN,
        element: <SubscriberMembers />,
      },
      {
        path: "/admin/test",
        element: <Test />,
      },
      {
        path: "*",
        element: <Navigate to={ROUTE_NAMES.COURSE_MANAGEMENT} />,
      },
    ],
  },
]);
